function useQuickOrderId() {
  const params = new URLSearchParams(window.location.search);
  return params.get("quickOrderId") || undefined;
}

export default useQuickOrderId;
